/* eslint-disable */
import React from 'react'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { IS_SERVER } from '../constants/ssr'
import { DEVICE_DEFAULT_MAX_SIZE } from '../lib/DEVICE_DEFAULT_MAX_SIZE'

const MEDIA_QUERY_JS = {
  lg: `width <= ${DEVICE_DEFAULT_MAX_SIZE.lg}`,
  md: `width <= ${DEVICE_DEFAULT_MAX_SIZE.md}`,
  sml: `width <= ${DEVICE_DEFAULT_MAX_SIZE.sml}`,
  sm: `width <= ${DEVICE_DEFAULT_MAX_SIZE.sm}`,
  xs: `width <= ${DEVICE_DEFAULT_MAX_SIZE.xs}`,
  ss: `width <= ${DEVICE_DEFAULT_MAX_SIZE.ss}`,
}
const keys = ['ss', 'xs', 'sm', 'sml', 'md', 'lg']

export function useWidth(MEDIA_QUERY) {
  let result = keys.reduce((output, key) => {
    const matches = useMediaQuery(MEDIA_QUERY[key].replace('@media ', ''))
    return !output && matches ? key : output
  }, null)
  if (!result) {
    /**
     * @do not remove width, used in eval
     */
    let width = IS_SERVER ? 1366 : window.innerWidth
    result = result = keys.reduce((output, key) => {
      let query = MEDIA_QUERY_JS[key]
      let matches = eval(`(function(width){return ${query};})`)
      return !output && matches(width) ? key : output
    }, null)
  }
  return result || 'lg'
}
